import type { ResourcesConfig } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

const sharedClientId = import.meta.env.VITE_COGNITO_SHARED_CLIENT_ID
const isSharedSession = Boolean(sharedClientId && import.meta.env.VITE_COOKIE_DOMAIN)

export const isLocalhostSignIn = !isSharedSession

export const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId:
        import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-northeast-1_XXXXXXXXX',
      userPoolClientId:
        sharedClientId ||
        import.meta.env.VITE_COGNITO_CLIENT_ID ||
        'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      loginWith: {
        oauth: {
          domain:
            import.meta.env.VITE_COGNITO_DOMAIN ||
            'hakuou-dev.auth.ap-northeast-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            import.meta.env.VITE_REDIRECT_SIGN_IN ||
              'http://localhost:5178/callback',
          ],
          redirectSignOut: [
            import.meta.env.VITE_REDIRECT_SIGN_OUT || 'http://localhost:5178',
          ],
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
}

// NOTE: Amplify.configure() の "後" に呼ぶ必要があるため main.tsx 側から明示的に実行する。
export function configureCookieStorage() {
  const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN
  if (!cookieDomain) return
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
      domain: cookieDomain,
      secure: true,
      path: '/',
      sameSite: 'lax',
    }),
  )
}
